import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";
interface AuthMenuLoaderProps extends React.HTMLAttributes<HTMLDivElement> {}
const AuthMenuLoader: React.FC<AuthMenuLoaderProps> = ({
  className,
  ...props
}) => <div {...props} className={`flex items-center w-[200px] h-[50px] ${className || ''}`} data-sentry-component="AuthMenuLoader" data-sentry-source-file="auth-menu-loader.tsx">
    <Skeleton className="h-10 w-10 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="auth-menu-loader.tsx" />
    <div className="ml-4 space-y-1">
      <Skeleton className="h-2 w-[120px] h-3 rounded-md" data-sentry-element="Skeleton" data-sentry-source-file="auth-menu-loader.tsx" />
      <Skeleton className="h-2 w-[80px] h-3 rounded-md" data-sentry-element="Skeleton" data-sentry-source-file="auth-menu-loader.tsx" />
    </div>
  </div>;
export default AuthMenuLoader;